import { getUserInfo } from 'helpers/StorageHelper';
import { useEffect } from 'react';
import { updateUserState } from 'store/auth/actions/AuthAction';

function CustomerHeaderInfo({ title, description }: { title?: string; description?: string }) {
  function checkLoggedinUser() {
    const userInfo = getUserInfo();
    if (userInfo) {
      updateUserState(userInfo);
    }
  }
  useEffect(() => {
    // store user info
    checkLoggedinUser();
  }, []);

  return (
    <>
      <meta charSet="utf-8" />
      <meta name="robots" content="noindex" />
      {title && <title>{title}</title>}
      {description && <meta name="description" content={title} />}
    </>
  );
}
export default CustomerHeaderInfo;
